import {
	IBaseStepHistory,
	IStepAssignedToUser,
	IStepHistoryComment,
} from "models/StepHistoryDetail";
import { PreferredSupplierData, SupplierData } from "models/SupplierUserModel";

export interface IBidSummaryGridDetail {
	bidId: number;
	bidNumber: string;
	description: string;
	procurementMethod: string;
	bidOriginator: string;
	prOriginator: string;
	requisitionNo: string;
	phase: string;
	bidStatusId: number;
	status: string;
	totalRows: number;
	procurementMethodAbbreviation: string;
	procurementMethodCategory: string;
	transactionType: string;
	departments: string;
	erpDbCompany: string;
	totalEstAmount: number;
	departmentWiseTotal: {
		department: string;
		totalEstAmount: number;
	}[];
	readyStepDetail: { bidStepId: number } | null;
	isConversion: boolean;
	eventDetails: IEventDetailGrid[];
}

export interface IEventDetailGrid {
	bidMeetingEventId: number;
	fromDate: string;
	toDate: string;
	fromTime: string;
	toTime: string;
}

export class BidStepHistoryEmitter {
	bidId: number = -1;
	bidStepId: number = -1;
	isCsdRfq: boolean = true;
	isSupplierBidding: boolean = true;
}

// export interface IBidStepHistory extends IBaseStepHistory {
// 	bidStepId: number;
// 	stepStatusId: number;
// 	bidId: number;
// 	bidStepStatusName: string;
// 	sequenceNumber: number;
// }

export interface IBidStepHistory {
	bidStepId: number;
	bidId: number;
	stepNumber: string;
	description: string;
	comments: IStepHistoryComment[];
	assignToUsers: IStepAssignedToUser[];
	duration?: string;
	averageDuration: string;
	completedDate?: Date;
	completedBy?: string;
	stepCompletedInPercentage: number;
	bidStepStatusName: string;
	modulePhaseId: number;
	isShowProcurementMethodSelection: boolean;
	isEditableProcurementMethodSelection: boolean;
}

export interface ISearchSupplierModel {
	bidSupplierId: number;
	supplierId: number;
	supplierNumber: string;
	maaaCsdNumber: string;
	companyName: string;
	contactPerson: string;
	telephone: string;
	email: string;
	supplies: string;
	rfqSent: string | null;
	responses: string | null;
	noOfAwards: string | null;
	totalValue: number | null;
	scorecard: string | null;
	commodityCount: number;
	isPrefered: boolean;
	csdStatusId: number | null;
}

export class IPreferredBidSupplier {
	supplierId?: number | null = null;
	bidProspectiveSupplierHistoryId?: number = -1;
	preferredNumber?: string | null = "PRFXXXX";
	noOfSupplier: number | null = null;
	reason: string = "";
	isPrefered: boolean = true;
	bidSuppliers: PreferredSupplierData[] | SupplierData[] = [];
	supplierIds: number[] = [];
	provinceIds: number[] = [];
	municipalityIds: number[] = [];
	bbbeeLevelIds: number[] = [];
	csdStatuses: string[] = [];
	minimunNumber: number | null = null;
}

export class PreferredBidSupplierModel {
	noOfSupplier: number | null = null;
	reason: string = "";
	isPrefered: boolean = true;
	supplierIds: number[] = [];
}
